export const A_STATUS = { sent: "Sent", opened: "Opened", in_progress: "In progress", completed: "Completed", expired: "Expired", cancelled: "Cancelled" };

export const RELIABILITY = {
  high: ["High reliability", "bg-success-tint text-success border-[#CADBCF]"],
  medium: ["Medium reliability", "bg-caution-tint text-caution border-[#E8D7B0]"],
  low: ["Low reliability", "bg-risk-tint text-risk border-[#E8C9C5]"],
};

export const DOMAIN_ORDER = [["O", "Openness"], ["C", "Conscientiousness"], ["E", "Extraversion"], ["A", "Agreeableness"], ["ES", "Emotional stability"]];

export const INDEX_ORDER = ["self_discipline", "dependability", "attention_detail", "drive", "assertiveness", "confrontational", "stress_tolerance", "teamwork", "adaptability"];

export const ALIGN_STATUS = {
  inside: ["Inside range", "bg-success-tint text-success border-[#CADBCF]"],
  slightly_outside: ["Slightly outside", "bg-caution-tint text-caution border-[#E8D7B0]"],
  far_outside: ["Far outside", "bg-risk-tint text-risk border-[#E8C9C5]"],
};

export const SJT_TYPES = ["leadership", "conflict", "team", "change"];

export const deviceInfo = () => `${/Mobi|Android/i.test(navigator.userAgent) ? "Mobile" : "Desktop"} · ${window.innerWidth}x${window.innerHeight} · ${navigator.userAgent.slice(0, 120)}`;

export const domainPct = (pcts, k) => (k === "ES" ? 100 - pcts.domains.N.pct : pcts.domains[k].pct);
export const domainBand = (pcts, k) => (k === "ES" ? [100 - pcts.domains.N.band[1], 100 - pcts.domains.N.band[0]] : pcts.domains[k].band);
